import React from "react";
import "./search-field.scss";
import SearchImg from "../../assets/search-white.svg";

const SearchField = ({stickeySearch, onChange}) => {
  return (
    <div className={stickeySearch?"sticky-search-field":"search-field"}>
      <div className="search-img">
        <img src={SearchImg} alt="search" />
      </div>
      <input type="search" className="form-control" placeholder="Search" 
      onChange={onChange}/>
    </div>
  );
};

export default SearchField;
